'use client';

import { useState } from 'react';

import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/components/atoms/LinkButton/LinkStrapi';
import type { PromoBadgeStrapi } from '@/components/atoms/PromoBadge';
import { RichTextFieldStrapiProps } from '@/components/atoms/RichTextField/RichTextFieldStrapi';

import { BlockComponentModel } from '@/cms/types/blok-component';
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '@/utils/browserStorage';

import { WelcomePopUp } from './WelcomePopUp';

export type WelcomePopUpStrapiProps = {
  image?: ImageStrapiProps;
  title: string;
  description: RichTextFieldStrapiProps;
  hiddenMobileText?: string;
  buttons?: LinkButtonStrapiProps[];
  promoBadge?: PromoBadgeStrapi | null;
};

const SESSION_STORAGE_KEY = 'is_welcome_pop_up_hidden';

export const WelcomePopUpStrapi = ({
  block,
}: BlockComponentModel<WelcomePopUpStrapiProps>) => {
  const { image, buttons } = block;
  const [isVisible, setIsVisible] = useState(
    !getSessionStorageItem(SESSION_STORAGE_KEY)
  );

  const handleClose = () => {
    setIsVisible(false);
    setSessionStorageItem(SESSION_STORAGE_KEY, 'true');
  };

  if (!isVisible) {
    return null;
  }

  const ctas = (
    <div className='mt-8 flex w-full flex-col gap-y-6 md:flex md:flex-row md:gap-x-6 md:gap-y-0'>
      {buttons?.map((button, index) => (
        <LinkButtonStrapi
          key={index}
          block={button}
          inner={{ classNames: { root: 'w-full' } }}
        />
      ))}
    </div>
  );

  return (
    <WelcomePopUp
      {...block}
      image={
        !!image && (
          <ImageStrapi
            block={image}
            inner={{
              classNames: {
                image: 'h-[200px] w-[200px]',
              },
            }}
          />
        )
      }
      buttons={buttons?.length ? ctas : null}
      onClose={handleClose}
    />
  );
};
